module.exports = __webpack_public_path__ + "static/media/who-we-are.c6060413.svg";